import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Svg } from "./Svg";
import { mdiLoading } from "@mdi/js";

const ProgressStyle = styled.div`
    height: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    color: ${props => props.theme.primaryLighter};
    >div {
        opacity: ${props => (props.$show ? "1" : "0")};
        transition: opacity 0.4s;
        >div {
            font-size: 12px;
            margin-top: 10px;
        }
    }
`;

export const Progress = React.memo(props => {
    const { loading, text, children } = props;
    const [show, setShow] = useState(false);

    useEffect(() => {
        let timer;
        if (loading) {
            timer = setTimeout(() => setShow(true), 200);
        } else {
            setShow(false);
        }
        return () => clearTimeout(timer);
    }, [loading]);

    const progress =
        <ProgressStyle $show={show}>
            <div>
                <Svg path={mdiLoading} loading={true} size="50" />
                <div>{text}</div>
            </div>
        </ProgressStyle>;

    return (
        <>{loading ? progress : children}</>
    );
});
